import CheckoutPaymentContainer from './CheckoutPaymentContainer';
export default CheckoutPaymentContainer;